import { forceLogout, shouldForceLogout } from "../auth/session"

// V produkci je API na stejne domene za reverzni proxy. Absolutni URL je
// potreba jen pri lokalnim vyvoji se samostatne bezicim frontendem.
const API_BASE_URL = process.env.REACT_APP_API_URL || "/api"

function buildUrl(path) {
  const cleanBase = API_BASE_URL.replace(/\/+$/, "")
  const cleanPath = path.startsWith("/") ? path : `/${path}`
  return `${cleanBase}${cleanPath}`
}

async function request(path, options = {}) {
  const controller = new AbortController()
  const timeoutMs = options.timeoutMs ?? 15000
  const timeout = setTimeout(() => controller.abort(), timeoutMs)

  try {
    const res = await fetch(buildUrl(path), {
      ...options,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(options.headers || {}),
      },
      signal: controller.signal,
    })

    const contentType = res.headers.get("content-type") || ""
    const isJson = contentType.includes("application/json")
    const data = isJson ? await res.json().catch(() => null) : await res.text().catch(() => "")

    if (!res.ok) {
      if (shouldForceLogout(res.status, path)) {
        forceLogout()
      }

      const message =
        (data && typeof data === "object" && data.message) ||
        (typeof data === "string" && data) ||
        `HTTP ${res.status}`

      const err = new Error(message)
      err.status = res.status
      err.data = data
      throw err
    }

    return data
  } finally {
    clearTimeout(timeout)
  }
}

export const apiClient = {
  get: (path, options) => request(path, { ...(options || {}), method: "GET" }),
  post: (path, body, options) =>
    request(path, { ...(options || {}), method: "POST", body: JSON.stringify(body ?? {}) }),
  put: (path, body, options) =>
    request(path, { ...(options || {}), method: "PUT", body: JSON.stringify(body ?? {}) }),
  patch: (path, body, options) =>
    request(path, { ...(options || {}), method: "PATCH", body: JSON.stringify(body ?? {}) }),
  del: (path, options) => request(path, { ...(options || {}), method: "DELETE" }),
}
